import { styled, css } from 'styled-components';
import { Media } from '../../../theme/Media';
export const TableWrapper = styled.div `
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  ${({ theme, inner }) => inner
    ? css `
          border: 1px solid ${theme.colors.grey10_1};
        `
    : theme.shadows.small}
`;
export const TableBody = styled.tbody `
  @media ${Media.xsMax} {
    display: block;
  }
`;
export const TableScrollableWrapper = styled.div `
  position: relative;
  overflow-x: auto;
`;
export const StyledTable = styled.table `
  width: 100%;
  border-collapse: separate;

  @media ${Media.xsMax} {
    display: flex;
    flex-direction: column;
  }
`;
